import { NgModule } from '@angular/core';
import { MuiButtonModule, MuiIconModule } from '@move/ui';
import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { MmuUserInfoDetails } from './models';
import { MmuPlanPermissionDialogComponent } from './plan-permission/plan-permission-dialog/mmu-plan-permission-dialog.component';
import { MmuPlanPermissionDirective } from './plan-permission/plan-permission-directive/mmu-plan-permission.directive';
import { MmuUserRoleDirective } from './user-role-directive/mmu-user-role.directive';
import { MmuUserService } from './user-service/mmu-user.service';
import { MmuUserTypeDirective } from './user-type-directive/mmu-user-type.directive';


/**
 * Initially load the logged-in user to get the username and roles before the application starts
 */
export const initUser = (userService: MmuUserService): () => Promise<MmuUserInfoDetails> => () => firstValueFrom(userService.load());

@NgModule({
  declarations: [
    MmuUserRoleDirective,
    MmuUserTypeDirective,
    MmuPlanPermissionDirective,
    MmuPlanPermissionDialogComponent
  ],
  imports: [
    MuiIconModule,
    MuiButtonModule,
    TranslateModule
  ],
  exports: [
    MmuUserRoleDirective,
    MmuUserTypeDirective,
    MmuPlanPermissionDirective,
    MmuPlanPermissionDialogComponent
  ]
})
export class MmuAuthModule {
}
